import { useCallback, useEffect, useState } from "react";
import Canvas1 from "../Canvas1";
import Hw5List from "./Hw5List";


import Script from "next/script";
// import { AnimateCC, GetAnimationObjectParameter } from "react-adobe-animate";

const initialAnimaciones = [
// const animaciones = [
  // { id: 1, name: "lishtml5", animurl: "/lishtml5.js", loaded: false, composition: "a" },
  // { id: 2, name: "ils1", animurl: "/image/ils1.js", loaded: false, composition: "b" },
  // { id: 3, name: "verticalspeed1", animurl: "/image/verticalspeed1.js", loaded: false , composition: "c" },
  // { id: 1, name: "lishtml5", animurl: "lishtml5.js", composition: "animation2" },
  // { id: 2, name: "ils1", animurl: "ils1.js", composition: "F42BBEB1D5E27943A0F71B0F22069701" },
  // { id: 3, name: "verticalspeed1", animurl: "image/verticalspeed1.js", composition: "E716904B9F00294587CFABDE82EDB438" },
  // { id: 4, name: "image", animurl: "/image/image.js", composition: "" },
  { id: 1, name: "lishtml5", animurl: "lishtml5.js", composition: "" },
  { id: 2, name: "ils1", animurl: "ils1.js", composition: "" },
  { id: 3, name: "verticalspeed1", animurl: "image/verticalspeed1.js", composition: "" },
  { id: 4, name: "image", animurl: "/image/image.js", composition: "" },
];


//https://solutions-script-component-strategies.vercel.app/
const Hw5 = () => {
  interface Log {
    time: Date;
    text: string;
  }

  // const [users, setUsers] = useState(initialUsers);
  const [animaciones, setAnimaciones] = useState(initialAnimaciones);
  // const areScriptsLoaded = isCreateJSLoaded && scriptsLoadedCount === 4;
  const [areScriptsLoaded, setAreScriptsLoaded] = useState(false);
  // const areScriptsLoaded = false;
  // const [animationObject, getAnimationObject] =
  //   useState<GetAnimationObjectParameter | null>(null);
    const [paused, setPaused] = useState(false);
    // const [composition, setComposition] = useState<string>();

    // const [log, setLog] = useState<Log[]>([]);
  const [log, setLog] = useState([]);
    // const [animationName, setAnimationName] = useState(
  //   "https://js.stripe.com/v3/"
  // );
  // const [animationName, setAnimationName] = useState(animaciones[2].name);
  // const [animationName, setAnimationName] = useState("verticalspeed1");
  const [animationName, setAnimationName] = useState("ils1");
  const [animationFile, setAnimationFile] = useState("/image/"+animationName+".js");
  
  const addLog = useCallback(
    (text: string) => {
      setLog((log) => log.concat({ time: new Date(), text }));
    }, [setLog]);

  // useEffect(() => {
  //   addLog("Page loaded window.Stripe is undefined");
  //   addLog("areScriptsLoaded ha cambiado a:"+areScriptsLoaded);
  // }, [areScriptsLoaded]);

  // useEffect(() => {
  //   addLog("animationName ha cambiado a:"+animationName);
  // }, [animationName]);

  const botonPr1 = () => {
   setAreScriptsLoaded(false);
   console.log("botonPr1 pulsado animationName ha cambiando a:"+animationName);
   setAnimationFile("/image/ils1.js");
   setAnimationName("ils1");

    addLog("botonPr1 pulsado animationName ha cambiando a:"+animationName);
  };

  const botonPr2 = () => {
    setAreScriptsLoaded(false);
    console.log("botonPr2 pulsado animationName ha cambiando a:"+animationName);
    setAnimationFile("/image/verticalspeed1.js");
    setAnimationName("verticalspeed1");
     addLog("botonPr2 pulsado animationName ha cambiando a:"+animationName);
  };

  // const onScriptLoad = () => {
  //   addLog(
  //     "Hw5 script cargado correctamente animationName..a:"+animationName
  //   )
  //   setAreScriptsLoaded(true);
  // };

  // const handleDelete = useCallback(
  //   (animacionId) => {
  //   console.log("handleDelete");
  // //     setUsers(users.filter((user) => user.id !== userId));
  // //   }, [users]
  // }, [animaciones]
  // );
  

  return (
    <>
      {/* We load the Stripe SDK afterInteractive */}
      {/* {!areScriptsLoaded && "Loading scripts..."} */}
        {/* {areScriptsLoaded && ( */}
      {/* <Script
        // src="https://js.stripe.com/v3/"
        // src={animationFile}
        src={"/image/ils1.js"}
        type="text/javascript"
        strategy="afterInteractive"
        onReady={onScriptLoad}
      /> */}
      {/* )} */}
      <div>
        <button onClick={botonPr1}>ils1 Pr1</button>
        <button onClick={botonPr2}>verticalS... Pr2</button>
      </div>
      <div style={{ width: "450px" }}>
      <h1>Texto de prueba 1</h1>

        {/* {!areScriptsLoaded && "Loading scripts..."}
        {areScriptsLoaded && (
          <AnimateCC
            animationName={animationName}
            composition={composition}
            getAnimationObject={getAnimationObject}
            onError={() => console.log("onError_2")}
            paused={paused}
          />
        )} */}
      </div>

      <section className="flex flex-col gap-6">
        <h1>lazyOnload Stripe sdk</h1>
        You can check window.Stripe on browser console
        {log.map(({ time, text }) => (
          <li key={+time}>
            <span className="font-medium">{time.toISOString()}</span>: {text}
          </li>
        ))}
      </section>
      <div style={{ background: "#d5e6db" }}>
            Simulacion2
            {/* <Canvas1></Canvas1> */}
          </div>
      <div>
      {/* <Canvas2List users={filteredUsers} handleDelete={handleDelete} /> */}
      <Hw5List animaciones={animaciones} />
      </div>

    </>
  );
};

export default Hw5;
